/*=============================================== VideoPage ===============================================*/

import { Video } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const VideoPage = () => {
    const items: ItemType[] = [
        {
            title: "With controls",
            content: (
                <Video src="https://assets.mixkit.co/videos/preview/mixkit-animation-of-futuristic-devices-99786-large.mp4" />
            ),
            code: '<Video src="https://assets.mixkit.co/videos/preview/mixkit-animation-of-futuristic-devices-99786-large.mp4" />',
        },
        {
            title: "Autoplay",
            content: (
                <Video
                    src="https://assets.mixkit.co/videos/preview/mixkit-animation-of-futuristic-devices-99786-large.mp4"
                    height="40vw"
                    autoPlay
                    fit="cover"
                />
            ),
            code: '<Video\n    src="https://assets.mixkit.co/videos/preview/mixkit-animation-of-futuristic-devices-99786-large.mp4"\n    height="40vw"\n    autoPlay\n    fit="cover"\n/>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "src",
            type: "string",
            required: true,
        },
        {
            subtitle: "width",
            type: "string or number",
            default: "100%",
        },
        {
            subtitle: "height",
            type: "string or number",
            default: "auto",
        },
        {
            subtitle: "fit",
            type: "string",
            possible: commonProps.objectFit,
        },
        {
            subtitle: "emptyText",
            intro: (
                <>
                    Text showing when the browser does not support the{" "}
                    <code>video</code> tag.
                </>
            ),
            type: "string",
            default: "Your browser doesn't support the video tag.",
        },
        {
            subtitle: "type",
            type: "string",
            possible: [
                "video/x-flv",
                "video/mp4",
                "application/x-mpegURL",
                "video/MP2T",
                "video/3gpp",
                "video/quicktime",
                "video/x-msvideo",
                "video/x-ms-wmv",
            ],
            default: "video/mp4",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default VideoPage
